import React, { useState } from 'react';
import { connect } from 'react-redux';
import { CampaignAction, UIAction } from 'redux/actions';
import PageSpinner from 'components/PageSpinner';
import { Input, Col, Card, CardBody } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import CampaignList from './campaignList';
import { TableCell, TableRow } from '@mui/material';
import DateRangePickerComp from 'components/DatePicker/DateRangePicker';
import moment from 'moment';
import Avatar from 'components/Avatar';
import noImage from 'assets/img/users/no-image.jpg';
import { ConvertLocalToUtc } from 'hooks';

const CampaignUsers = (props) => {

    const campaignStatus = ['Draft', 'Pending', 'Approved', 'Declined', 'Running', 'Paused', 'Completed'];
    const campaignActionStatus = ['Draft', 'Pending', 'Approved', 'Declined', 'Paused'];
    let [renderKey, setRenderKey] = React.useState(Math.random());
    let [filterReset, setFilterReset] = React.useState(Math.random());
    let [filters, setFilters] = useState(props.campaignFilters);
    const [pagination, setPagination] = React.useState({
        page: 0,
        page_limit: 10,
    });
    const [order, setOrder] = React.useState({
        order_by: `created_at`,
        direction: 'desc'
    });


    const handleDateChange = (date) => {
        setFilters({ ...filters, [`date_range`]: date })
    }

    const handleSearch = () => {
        let startDateString = filters && filters.date_range && filters.date_range.startDate ? moment(filters.date_range.startDate).format('YYYY-MM-DD') : '';
        let endDateString = filters && filters.date_range && filters && filters.date_range.endDate ? moment(filters && filters.date_range.endDate).format('YYYY-MM-DD') : '';

        startDateString = ConvertLocalToUtc(startDateString,'YYYY-MM-DD');
        endDateString = ConvertLocalToUtc(endDateString,'YYYY-MM-DD');
        

        let filter = {
            ad_name: (filters && filters.ad_name) ? filters.ad_name : '',
            keyword: (filters && filters.query) ? filters.query : '',
            capnStatus: (filters && filters.transaction_type) ? filters.transaction_type : '',
            start_date: startDateString,
            end_date: endDateString,
            page: (filters && filters.pagination) ? filters.pagination.page : 0,
            page_limit: (filters && filters.pagination) ? filters.pagination.page_limit : 10,
            order_by: (filters && filters.order) ? filters.order.order_by : 'id',
            direction: (filters && filters.order) ? filters.order.direction : 'desc',
            deleted:(props.deleted)?props.deleted:0
        }

        props.getCampaignsUsers(filter);
    }

    React.useEffect(() => {

        //setFilters({ ...filters, [`pagination`]: pagination })
        //setFilters({ ...filters, [`order`]: order });
        //let filterData = 
        filters = { ...filters, [`pagination`]: pagination };
        filters = { ...filters, [`order`]: order };
        setFilters(filters);
        console.log('filters--------------->>>>', filters)
    }, [pagination, order]);

    
    React.useEffect(() => {
        
        handleSearch();
    }, [props.deleted]);


    const columns = () => {
        const cols = [
            { name: "id", label: "User Id" },
            { name: "avatar", label: "Profile Picture" },
            { name: "name", label: "Name" },
            { name: "username", label: "Username" },
            { name: "email", label: "Email" },
            { name: "phone", label: "Phone" },
        ];
        return cols.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    display: (column.name === 'id') ? false : true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (tableMeta.columnData.name === 'avatar') {
                            return (<Avatar src={(value) ? value : noImage} />);
                        } else {
                            return value;
                        }
                    }
                }
            }
        })
    }
    const options = {
        rowsExpanded: props.rowsExpanded,
        onRowExpansionChange: data => {
            const index = data[0].index;
            if (props.rowsExpanded.includes(index)) {
                props.setRowsExpanded([])
            } else {
                props.setRowsExpanded([data[0].index])
            }
        },
        tableId: 'datatable',
        filterType: 'checkbox',
        search: false,
        responsive: "simple",
        filter: false,
        download: false,
        print: false,
        selectableRows: 'none',
        viewColumns: false,
        count: props.totalCount,
        serverSide: true,
        page: pagination.page,
        rowsPerPage: pagination.page_limit,
        onColumnSortChange: (changedColumn) => {
            setOrder({
                order_by: changedColumn,
                direction: (order.direction === 'asc') ? 'desc' : 'asc'
            })
        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    
                    setPagination({
                        page_limit: pagination.page_limit,
                        page: tableState.page
                    })
                    break;
                case 'changeRowsPerPage':
                    setPagination({
                        page_limit: tableState.rowsPerPage,
                        page: 0,
                    })
                    break;
                default:
                    break
            }
        },
        expandableRowsHeader: false,
        expandableRows: true,
        expandableRowsOnClick: true,
        setRowProps: (row, dataIndex, rowIndex) => {
            return {
                style: { background: '#f2f2f2' },
            };
        },
        renderExpandableRow: (rowData, rowMeta) => {
            /* if (!rowsExpanded.includes(rowMeta.rowIndex)) {
                 rowsExpanded.push(rowMeta.rowIndex)
             }
             setRowsExpanded(rowsExpanded)*/

            return (
                <>
                    <TableRow className='campaign-child-table' key={rowData}>
                        <TableCell colSpan={6}>
                            <CampaignList renderKey={`${rowData[0]}-${renderKey}`} userId={rowData[0]} filter={
                                {
                                    deleted:(props.deleted)?props.deleted:0,
                                    ad_name: (filters && filters.ad_name) ? filters.ad_name : '',
                                    keyword: (filters && filters.query) ? filters.query : '',
                                    capnStatus: (filters && filters.transaction_type) ? filters.transaction_type : '',
                                    start_date: (filters && filters.date_range && filters.date_range.startDate) ? moment(filters.date_range.startDate).format('YYYY-MM-DD') : '',
                                    end_date: (filters && filters.date_range && filters.date_range.endDate) ? moment(filters.date_range.endDate).format('YYYY-MM-DD') : '',
                                }} campaignStatus={campaignActionStatus} />
                        </TableCell>
                    </TableRow>
                </>
            );
        },
    };

    React.useEffect(() => {
        //setRenderKey(Math.random());
    }, [props.campaignUsers])

    React.useEffect(() => {
        props.setCampaignFilters(filters);
        handleSearch();
        console.log('filters---------->', filters)
    }, [filters])


    const resetSearch =()=>{
        setFilters({ ...filters, [`transaction_type`]: '', [`ad_name`]: '',[`query`]: '',[`date_range`]:'' });
        props.setRowsExpanded([]);
        setRenderKey(Math.random());
        setFilterReset(Math.random());
    }

    React.useEffect(()=>{
        handleSearch();
        //props.setRowsExpanded([]);
    },[filterReset]);


    console.log('filters.date_range', filters)
    return (
        <>
            <Card>
                <CardBody className="bottomShadow">
                    <DateRangePickerComp
                        key={renderKey}
                        resetButton={true}
                        buttonStyle={{marginTop:'-3px'}}
                        label={'Ad Created'} 
                        handleDateChange={handleDateChange} 
                        handleSearch={() => {
                            handleSearch();
                            props.setRowsExpanded([]);
                        }} 
                        resetSearch={() => {
                            
                            resetSearch();
                        }}
                        defaultRange={(filters && filters.date_range) ? filters.date_range : ''} >

                        <Col lg={2} md={2} sm={4} xs={12} >
                            <span style={{ fontSize: 14 }}>Campaign</span>
                            <Input
                                type="text"
                                name="ad_name"
                                id="ad_name"
                                onChange={(event) => {
                                    setFilters({ ...filters, [`ad_name`]: event.target.value })
                                }}
                                autoComplete={'off'}
                                value={(filters && filters.ad_name) ? filters.ad_name : ''}
                                placeholder={'Search by ad'}
                                style={{ width: '100%', marginBottom: 10 }}
                            />
                        </Col>


                        <Col lg={2} md={2} sm={4} xs={8} >
                            <span style={{ fontSize: 14 }}>Customer</span>
                            <Input
                                type="text"
                                name="query"
                                id="query"
                                onChange={(event) => {
                                    setFilters({ ...filters, [`query`]: event.target.value })
                                }}
                                autoComplete={'off'}
                                value={(filters && filters.query) ? filters.query : ''}
                                placeholder={'Search by customer'}
                                style={{ width: '100%', marginBottom: 10 }}
                            />
                        </Col>
                        <Col lg={2} md={2} sm={4} xs={12}>
                            <span style={{ fontSize: 14 }}>Campaign Status</span>
                            <Input name={'transaction_type'}
                                onChange={(e) => {
                                    setFilters({ ...filters, [`transaction_type`]: e.target.value })
                                }}
                                value={(filters && filters.transaction_type) ? filters.transaction_type : ""}
                                className="mb-2"
                                type="select"
                                style={{ width: '100%' }}>
                                <option value={0}>All</option>
                                {
                                    campaignStatus.map((item) => {
                                        return <option key={item} value={item}>{item}</option>
                                    })
                                }
                            </Input>
                        </Col>
                    </DateRangePickerComp>
                </CardBody>
            </Card>
            <br />
            {props.isLoading ? <PageSpinner />
                : <MUIDataTable data={props.campaignUsers} columns={columns()} options={options} />
            }


        </>
    );
}

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    campaignUsers: (state.campaign && state.campaign.campaignUsers && state.campaign.campaignUsers.data) ? state.campaign.campaignUsers.data : [],
    totalCount: (state.campaign && state.campaign.campaignUsers &&
        state.campaign.campaignUsers.totalCampaigns) ? state.campaign.campaignUsers.totalCampaigns : 0,

    campaignFilters: (state.uiReducer && state.uiReducer.campaignFilters) ? state.uiReducer.campaignFilters : null,
    rowsExpanded: (state.uiReducer && state.uiReducer.expandedRow) ? state.uiReducer.expandedRow : [],

});
const mapDispatchToProps = (dispatch) => ({
    getCampaignsUsers: (payload) => dispatch(CampaignAction.getCampaignsUsers(payload)),
    setRowsExpanded: (payload) => dispatch(UIAction.setExpandedRow(payload)),
    setCampaignFilters: (payload) => dispatch(UIAction.setCampaignFilters(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignUsers);
